export const environment = {
  production: false,
  environment: 'Dev',
  authorized: {
    url: "https://ahorramasext.b2clogin.com/ahorramasext.onmicrosoft.com/B2C_1_Prueba_APP/oauth2/v2.0/authorize",
    clientId: '6706d415-0ad9-4b69-a3a2-ce33e790af58',
    redirectUrl: 'https://portal-proveedores-dev.ahorramas.es/oauthresponse',
    scope: 'https://ahorramasext.onmicrosoft.com/portal-proveedores/read',
    typeUsers: "external" //Tipo de validación establecido en el UI
  },

  storageType: 'sessionStorage', // Opciones disponibles actualmente: sessionStorage, localStorage

  uiService: {
    url: 'https://apides.ahorramas.com/provider-portal'
  }

};